import { useContext } from "react";
import ExternalValueActionsContext from "views/components/ExternalValueActionsContext";
const useExternalValueActions = () => useContext(ExternalValueActionsContext);
export default useExternalValueActions;
